// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import createError from 'http-errors';

export const FetchDecrypt = async (key: string): Promise<any> => {
  const response = await fetch('/api/decrypt', {
    method: 'POST',
    body: JSON.stringify({
      key: key
    }),
    headers: {
      'content-type': 'application/json;charset=UTF-8'
    }
  });
  if (response.status !== 200) {
    throw createError(
      response.status,
      `Unable to retrieve config. Status: ${response.status}. Message: ${response.statusText}.`
    );
  }

  const responseContent = await response.text();
  const meetingLink = JSON.parse(responseContent);
  if (!meetingLink) {
    throw new Error(`Received empty config response.`);
  }
  //console.log({ responseContent, meetingLink });

  //   const appConfigModel: AppConfigModel = {
  //     ...config,
  //     theme: generateTheme(config.colorPalette)
  //   };

  return meetingLink;
};
